<div class="booble-backdrop-drawer-right">
  <div class="drawer-rtl-in">
    <div
      class="drawer-content-lg drawer-documents"
    >
      <!-- Header -->
      <div class="row padding-left-32 drawer-header">
        <div class="col-md-11">
          <div class="d-flex flex-column">
            <h2 class="title-modal">Upload de comprovantes</h2>
            <p class="p-text-grey-scale-dark mg-bottom-24">
              Confira as informações dos comprovantes antes de confirmar o
              upload
            </p>
          </div>
        </div>

        <div class="col-md-1 d-flex justify-content-end mg-top-10">
          <div (click)="closeModal()" class="close-icon tappable">
            <img src="assets/image/close-modal-icon.svg" />
          </div>
        </div>
      </div>

      <!-- Content: Table + PDF side by side -->
      <div class="modal-dialog-scrollable-general">
        <div class="content-wrapper">
          <!-- Table panel -->
          <div class="table-panel">
            <div class="modal-body h-100">
              <div class="list-actions">
                <div
                  *ngIf="!loading"
                  class="d-flex col-md-12 header justify-content-between align-items-center"
                >
                  <span class="black-text" *ngIf="totalElements > 0">
                    {{ totalElements }} comprovantes a confirmar
                  </span>

                  <div class="search-container">
                    <input
                      type="text"
                      placeholder="Pesquisar"
                      class="search-input"
                      [(ngModel)]="searchText"
                      (ngModelChange)="onSearchChange($event)"
                    />
                    <img class="search-icon" src="assets/image/search.svg" />
                  </div>
                </div>

                <ng-container *ngIf="orders.length > 0 && !loading">
                  <!-- Table header -->
                  <div class="row items-list align-items-center">
                    <div class="label-header col-4">Cliente</div>
                    <div class="label-header col-2">Valor</div>
                    <div class="label-header col-2">Liquidação</div>
                    <div class="label-header col-2">Nº Boleto</div>
                    <div class="label-header col-2 text-center">Ações</div>
                  </div>

                  <!-- Table rows -->
                  <div
                    *ngFor="let item of orders"
                    class="row items-list align-items-center tappable"
                    [class.selected-row]="selectedOrder?.id === item.id"
                    (click)="selectOrder(item)"
                  >
                    <div class="col-4">
                      <span class="label-value client-name" [title]="getClientName(item)">
                        {{ getClientName(item) }}
                      </span>
                      <br />
                      <span *ngIf="item.corporateAccount" class="label-value-bold">CNPJ: </span>
                      <span *ngIf="item.corporateAccount" class="label-value" [title]="item.corporateAccount?.cnpj">
                        {{ (item.corporateAccount?.cnpj || '') | mask: "AA.AAA.AAA/AAAA-00" }}
                      </span>
                      <span *ngIf="!item.corporateAccount" class="label-value-bold">CPF: </span>
                      <span *ngIf="!item.corporateAccount" class="label-value" [title]="item.individualAccount?.cpf">
                        {{ (item.individualAccount?.cpf || '') | mask: "000.000.000-00" }}
                      </span>
                    </div>
                    <div class="col-2" [title]="item.amount">
                      <span class="label-currency">{{ item.currency?.description }}</span>
                      <span class="label-value">
                        {{ item.amount | number: "1.2-2" }}</span>
                    </div>
                    <div class="col-2">
                      <span>{{
                        item.settlementDate | date: "dd/MM/yyyy"
                      }}</span>
                    </div>
                    <div class="col-2" [title]="item?.slipCode">
                      <span class="slip-code-container">
                        {{ item?.slipCode }}
                      </span>
                    </div>
                    <div class="col-2 actions-cell">
                      <ng-container *ngIf="!isProcessing(item.id)">
                        <button
                          class="btn-action btn-approve"
                          (click)="approveOrder(item, $event)"
                          title="Aprovar upload"
                        >
                          <img src="assets/image/new-check-approve.svg" />
                        </button>
                        <button
                          class="btn-action btn-reject"
                          (click)="rejectOrder(item, $event)"
                          title="Reprovar upload"
                        >
                          <img src="assets/image/close-icon.svg" />
                        </button>
                      </ng-container>
                      <span class="spinner-border spinner-border-sm" *ngIf="isProcessing(item.id)"></span>
                    </div>
                  </div>
                </ng-container>

                <!-- Loading -->
                <ng-container *ngIf="loading">
                  <div class="row not-found align-items-center">
                    <span class="spinner-border text-primary"></span>
                  </div>
                </ng-container>

                <!-- Empty -->
                <ng-container *ngIf="orders.length === 0 && !loading">
                  <div class="row not-found align-items-center">
                    <span class="grey-text"
                      >Nenhum comprovante pendente de confirmação.</span
                    >
                  </div>
                </ng-container>
              </div>

              <!-- Pagination -->
              <div
                *ngIf="orders.length > 0 && !loading"
                class="list-actions page"
              >
                <mat-paginator
                  class="custom-paginator"
                  [pageIndex]="pageNumber"
                  [pageSize]="pageSize"
                  [length]="totalElements"
                  (page)="onChangePage($event)"
                  [pageSizeOptions]="[5, 10, 25, 50]"
                  showFirstLastButtons
                ></mat-paginator>
              </div>
            </div>
          </div>

          <!-- PDF panel (right side, always present) -->
          <div class="pdf-panel" *ngIf="selectedOrder">
            <div class="pdf-header">
              <div class="pdf-controls">
                <button
                  class="pdf-control-btn"
                  (click)="previousPage()"
                  [disabled]="pdfCurrentPage <= 1"
                >
                  ‹
                </button>
                <span class="pdf-page-info"
                  >{{ pdfCurrentPage }} / {{ pdfTotalPages }}</span
                >
                <button
                  class="pdf-control-btn"
                  (click)="nextPage()"
                  [disabled]="pdfCurrentPage >= pdfTotalPages"
                >
                  ›
                </button>

                <span class="pdf-separator">|</span>

                <button class="pdf-control-btn" (click)="zoomOut()">−</button>
                <span class="pdf-page-info tappable" (click)="resetZoom()"
                  >{{ zoomPercentage }}%</span
                >
                <button class="pdf-control-btn" (click)="zoomIn()">+</button>

                <span class="pdf-separator">|</span>

                <button class="pdf-control-btn" (click)="downloadPdf()" title="Download PDF">
                  ↓
                </button>
              </div>
            </div>

            <div class="pdf-viewer-area">
              <ng-container *ngIf="pdfLoading">
                <div class="pdf-loading">
                  <span class="spinner-border text-primary"></span>
                </div>
              </ng-container>

              <ng-container *ngIf="!pdfLoading && pdfSrc">
                <pdf-viewer
                  [src]="pdfSrc"
                  [page]="pdfCurrentPage"
                  [zoom]="pdfZoom"
                  [show-all]="false"
                  [render-text]="true"
                  [original-size]="false"
                  [fit-to-page]="true"
                  (after-load-complete)="onPdfLoaded($event)"
                ></pdf-viewer>
              </ng-container>
            </div>
          </div>

          <!-- Placeholder when no PDF selected -->
          <div class="pdf-placeholder" *ngIf="!selectedOrder">
            <span>Selecione um comprovante para visualizar o PDF</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Confirm reject overlay -->
  <div class="confirm-overlay" *ngIf="showRejectConfirm">
    <div class="confirm-dialog">
      <div class="confirm-header">
        <span class="confirm-title">Reprovar upload</span>
        <div (click)="cancelReject()" class="close-icon tappable">
          <img src="assets/image/close-modal-icon.svg" />
        </div>
      </div>
      <div class="confirm-body">
        <p>Tem certeza que deseja reprovar o upload? O comprovante só poderá ser anexado de maneira manual</p>
      </div>
      <div class="confirm-footer">
        <button type="button" class="btn btn-outline-primary" [style.width]="'95px'" (click)="cancelReject()">Não</button>
        <button type="button" class="btn btn-dark-primary-blue btn-footer" (click)="confirmReject()">Confirmar</button>
      </div>
    </div>
  </div>
</div>
